import React, { useRef, useState } from "react"
import { IconButton, Typography } from "@mui/material"
import VolumeUpIcon from "@mui/icons-material/VolumeUp"
import TimerIcon from "@mui/icons-material/Timer"
import { useAudioSettingsContext } from "contexts/AudioSettingsContext"
import SpeedOptions from "./SpeedOptions"
import VolumeOptions from "./VolumeOptions"
import { styles } from "../themes/bluePlayer.styles"

const Controllers = () => {
  const { audioSettings } = useAudioSettingsContext()
  const [optionSpeedExpanded, setOptionSpeedExpanded] = useState(false)
  const [optionVolumeExpanded, setOptionVolumeExpanded] = useState(false)
  const speedAnchorRef = useRef(null)
  const volumeAnchorRef = useRef(null)

  const closeSpeedOptions = (event) => {
    // if (speedAnchorRef.current && speedAnchorRef.current.contains(event.target)) {
    //   return;
    // }
    event?.stopPropagation()
    setOptionSpeedExpanded(false)
  }

  return (
    <React.Fragment>
      <IconButton
        ref={volumeAnchorRef}
        id="volume-options-button"
        aria-controls={optionVolumeExpanded ? "volume-options" : undefined}
        aria-expanded={optionVolumeExpanded ? "true" : undefined}
        aria-haspopup="true"
        onClick={(e) => {
          e.stopPropagation()
          setOptionSpeedExpanded(false)
          setOptionVolumeExpanded(!optionVolumeExpanded)
        }}
      >
        <VolumeUpIcon sx={styles.controllerActionIcon} />
      </IconButton>
      <IconButton
        ref={speedAnchorRef}
        id="speed-options-button"
        aria-controls={optionSpeedExpanded ? "speed-options" : undefined}
        aria-expanded={optionSpeedExpanded ? "true" : undefined}
        aria-haspopup="true"
        onClick={(e) => {
          e.stopPropagation()
          setOptionVolumeExpanded(false)
          setOptionSpeedExpanded(!optionSpeedExpanded)
        }}
      >
        <Typography>{audioSettings?.speedLabel}</Typography>
        <TimerIcon sx={styles.controllerActionIcon} />
      </IconButton>
      <SpeedOptions
        open={optionSpeedExpanded}
        anchorRef={speedAnchorRef}
        onClose={closeSpeedOptions}
      />
      <VolumeOptions
        open={optionVolumeExpanded}
        anchorRef={volumeAnchorRef}
        onClose={() => setOptionVolumeExpanded(false)}
      />
    </React.Fragment>
  )
}

export default Controllers
